export const GONE = 'This leaderboard no longer exists.';
export const UNPUBLISHED = 'This leaderboard hasn’t published standings yet.';
export const NOBODY = 'Nobody has scored on this leaderboard yet.';

/** The standings read answered 404: the board is gone (deleted, or in a room this reader can no longer read). */
export function isGone(error: unknown): boolean {
  return typeof error === 'object' && error !== null && (error as { status?: unknown }).status === 404;
}

/**
 * The sentence the standings card shows in place of rows, or null where there are rows (#237).
 *
 * A failed read used to fall through to the empty-standings sentences: a board deleted while the portal's list was
 * cached answered 404 and read as "hasn't published standings yet" — wait, when there is nothing to wait for. A 404
 * now says the board is gone, any other failure says the standings could not be loaded and why (`describe` is
 * `describeApiError`, passed in so this module imports nothing), and only a read that succeeded can say nothing is
 * published or nobody has scored.
 *
 * `hasData` is whether standings are already on screen. A refetch that fails behind them keeps them — a passing
 * failure is no reason to blank a board — except a 404, which says the board is gone whatever was read before.
 */
export function standingsNotice(
  q: { error: unknown; hasData?: boolean; published: number | null; rows: number },
  describe: (error: unknown) => string | null,
): string | null {
  if (q.error && isGone(q.error)) return GONE;
  if (q.error && !q.hasData) {
    const why = describe(q.error);
    return why ? `The standings couldn’t be loaded. ${why}` : 'The standings couldn’t be loaded.';
  }
  if (q.rows > 0) return null;
  return q.published === null ? UNPUBLISHED : NOBODY;
}
